export default {
      id: "checked-usage",
      viewBox: "0 0 14 11",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#checked-usage",
      toString: function () {
        return this.url;
      }
    }